import { themeVars } from '../theme/vars';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';
import { style } from '../layer.css';

export const radioLabel = style({
  ...typography['bodyMd'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s16,
  cursor: 'pointer',
  transition: '.1s',
  position: 'relative',
  backgroundColor: themeVars.container.secondary.background.idle,
  borderRadius: borderRadius.r16,
  padding: `${space.s12}px ${space.s14}px`,
  color: themeVars.container.foreground.tertiary,

  selectors: {
    '&:has(input:checked)': {
      color: themeVars.container.foreground.primary,
    },
  },
});
